import { AlertTriangle, LoaderCircle, RefreshCw, SearchX } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "./ui/button";
import { cn } from "@/lib/utils";
import {
  pageErrorClass,
} from "@/components/ui/atoms";
import {
  pageStateClass,
} from "@/components/ui/chrome";

export function PageLoading({
  label = "Carregando dados operacionais...",
}: {
  label?: string;
}) {
  return (
    <output className={pageStateClass}>
      <LoaderCircle className="spin" aria-hidden="true" />
      <strong>{label}</strong>
    </output>
  );
}

/**
 * TUT-472 (Q044) — o registro do endereço não existe. Não é falha de rede, e
 * "Tentar novamente" não o faria aparecer: a saída é o caminho de volta, que
 * quem chama passa em `children`.
 */
export function PageNotFound({
  title,
  message,
  children,
}: {
  title: string;
  message: string;
  children: ReactNode;
}) {
  return (
    <div className={pageStateClass} role="alert">
      <SearchX aria-hidden="true" />
      <strong>{title}</strong>
      <p>{message}</p>
      {children}
    </div>
  );
}

export function PageError({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className={cn(pageStateClass, pageErrorClass)} role="alert">
      <AlertTriangle aria-hidden="true" />
      <strong>Não foi possível carregar esta área</strong>
      <p>{message}</p>
      {onRetry && (
        <Button variant="vidro" type="button" onClick={onRetry}>
          <RefreshCw aria-hidden="true" />
          Tentar novamente
        </Button>
      )}
    </div>
  );
}
